export * from "./user.service";
export * from "./dashboard.service";
export * from "./alerts.service";
export * from "./energy.service";
export * from "./rankings.service";
export * from "./appliances.service";
export * from "./appliance.service";
export * from "./account.service";
export * from "./activity.service";
export * from "./activityDetail.service";
export * from "./setup.service";
export * from "./feedback.service";
export * from "./popup.service";
export * from "./password.service";
export * from "./accountHomeView.service";

export const BASE_URL =
  process.env.NODE_ENV === "production"
    ? `${process.env.PUBLIC_URL}/api/v3`
    : "https://infocare-stg.informetis.com/api/v3";

export const BASE_URL_LEGACY = BASE_URL;
// process.env.NODE_ENV === "production"
//   ? `${process.env.PUBLIC_URL}/api/v2`
//   : "https://infocare-v3-stg.informetis.com/api/v2";

// export const BASE_URL_V3 =
//   process.env.NODE_ENV === "production"
//     ? `${process.env.PUBLIC_URL}/api/v3`
//     : "https://infocare-v3-stg.informetis.com";
// // "https://infocare-stg.informetis.com/api/v3";

// export const BASE_URL =
//   // = BASE_URL_V3;
//   process.env.NODE_ENV === "production"
//     ? `${process.env.PUBLIC_URL}/api/v2`
//     : // : // : "https://altrial.informetis.com/api/v1";
//       // "https://34.76.142.128/api/v2";
//       "https://infocare-stg.informetis.com/api/v2";
